import React, { useEffect, useState } from 'react';
import axios from 'axios';
import A1 from '../Images/logo-w.png';
import { useParams } from 'react-router-dom';

const PollSelectform = () => {
    const { userId } = useParams(); // Get userId from URL params
    const [polls, setPolls] = useState([]);
    const [selectedPoll, setSelectedPoll] = useState(null);
    const [selectedOptions, setSelectedOptions] = useState({}); // Changed to an object
    const [error, setError] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    useEffect(() => {
        axios.get(`https://rvapi.emedha.in/pages/api/api/polls?user_id=${userId}`)
            .then((response) => {
                setPolls(response.data);
            })
            .catch((err) => {
                setError('Error fetching polls');
                console.error('Error fetching polls:', err);
            });
    }, [userId]);

    const handleSelectPoll = (pollId) => {
        setSelectedPoll(pollId);
        setSelectedOptions((prevState) => ({
            ...prevState,
            [pollId]: ''
        }));
    };

    const handleSelectOption = (event, pollId) => {
        setSelectedOptions((prevState) => ({
            ...prevState,
            [pollId]: event.target.value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!selectedPoll || !selectedOptions[selectedPoll]) {
            setError('Please select a poll and an option.');
            return;
        }

        axios.post('https://rvapi.emedha.in/pages/api/pages/api/api/vote', {
            pollId: selectedPoll,
            option: selectedOptions[selectedPoll],
        })
            .then((response) => {
                console.log(response);
                alert('Your vote has been submitted!');
                setIsSubmitted(true); // Mark the poll as submitted
                setError(null);
            })
            .catch((err) => {
                setError('Error submitting vote');
                console.error('Error submitting vote:', err);
            });
    };

    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
        } else {
            console.log('No user data found in session storage');
        }
    }, []);



    useEffect(() => {
        if (user && user.id) {
            fetchEvents();
        } else {
            console.log('User is missing or incomplete');
        }
    }, [user]);


    const fetchEvents = async () => {
        if (!user || !user.id) {
            console.error('User ID is missing');
            return;
        }
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f7f7f7', maxWidth: '900px', margin: '30px auto', padding: '25px', borderRadius: '10px', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)' }}>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <img src={events && events.length > 0 ? events[0].file : ''} alt="Logo" style={{ width: '100px', }} />
                <h2 style={{ color: '#2c3e50', fontSize: '28px', fontWeight: '700', marginBottom: '20px' }}>
                    {events && events.length > 0 ? events[0].name : 'No event available'}
                </h2>
                <p style={{ color: '#7f8c8d', fontSize: '16px' }}>
                    Welcome to the Poll Section! Your feedback is invaluable to us.
                </p>
            </div>

            {polls.length === 0 ? (
                <p style={{ textAlign: 'center', fontSize: '18px', color: '#e74c3c' }}>No polls available at the moment. Please try again later!</p>
            ) : (
                <div>
                    {polls.map((poll) => (
                        <div
                            key={poll.id}
                            style={{
                                marginBottom: '30px',
                                padding: '20px',
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                cursor: 'pointer',
                                border: selectedPoll === poll.id ? '2px solid #3498db' : 'none',
                            }}
                            onClick={() => handleSelectPoll(poll.id)}
                        >
                            <h3 style={{ color: '#2c3e50', fontSize: '20px', marginBottom: '15px' }}>{poll.question}</h3>
                            <div style={{ marginBottom: '15px' }}>
                                <div style={{ marginBottom: '10px' }}>
                                    <input
                                        type="radio"
                                        id={`option1-${poll.id}`}
                                        name={`pollOption-${poll.id}`}
                                        value="Yes"
                                        checked={selectedOptions[poll.id] === "Yes"}
                                        onChange={(e) => handleSelectOption(e, poll.id)}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <label htmlFor={`option1-${poll.id}`} style={{ color: '#34495e', fontSize: '16px' }}>Yes</label>
                                </div>
                                <div>
                                    <input
                                        type="radio"
                                        id={`option2-${poll.id}`}
                                        name={`pollOption-${poll.id}`}
                                        value="No"
                                        checked={selectedOptions[poll.id] === "No"}
                                        onChange={(e) => handleSelectOption(e, poll.id)}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <label htmlFor={`option2-${poll.id}`} style={{ color: '#34495e', fontSize: '16px' }}>No</label>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div style={{ textAlign: 'center' }}>
                        {selectedPoll && selectedOptions[selectedPoll] && !isSubmitted && (
                            <button
                                onClick={handleSubmit}
                                style={{
                                    padding: '12px 20px',
                                    fontSize: '16px',
                                    color: '#fff',
                                    backgroundColor: '#2ecc71',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#27ae60'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#2ecc71'}
                            >
                                Submit Poll
                            </button>
                        )}
                        {isSubmitted && (
                            <button
                                disabled
                                style={{
                                    padding: '12px 20px',
                                    fontSize: '16px',
                                    color: '#fff',
                                    backgroundColor: '#bdc3c7',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'not-allowed',
                                }}
                            >
                                Poll Submitted
                            </button>
                        )}
                    </div>
                </div>
            )}
            {error && <div style={{ color: '#e74c3c', fontSize: '16px', textAlign: 'center', marginTop: '20px' }}>{error}</div>}
        </div>
    );
};

export default PollSelectform;
